<template>
  <CSelect
    v-model:value="selectedOption"
    bordered
    :options="options"
    :placeholder="t('canvasUI.CTagsPlaceholder.selectAction')"
    :style="{
      backgroundColor: themeVars.primary6,
      '--n-text-color': themeVars.text2,
    }"
    @update:value="handleOptionSelect"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import CSelect from '@lib/components/CSelect/CSelect.vue'

import useThemeVars from '@lib/composables/useThemeVars'

const { t } = useI18n()
const themeVars = useThemeVars()

const emit = defineEmits<{
  select: [action: string]
}>()

const options = [
  { label: t('canvasUI.CTagsPlaceholder.keepAsIs'), value: 'keep' },
  { label: t('canvasUI.CTagsPlaceholder.addNew'), value: 'add' },
  { label: t('canvasUI.CTagsPlaceholder.findAndRemove'), value: 'remove' },
  // { label: t('canvasUI.CTagsPlaceholder.replaceAll'), value: 'replace' }, // not supported yet by the backend
  // { label: t('canvasUI.CTagsPlaceholder.clearAll'), value: 'clear' }, // not supported yet by the backend
]

const selectedOption = ref<string | null>('keep')

function handleOptionSelect(value: string | null) {
  if (value) {
    emit('select', value)
  }
}
</script>
